import { ArrowRight, Check, LogOut } from "lucide-react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog";

type LogoutConfirmDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  pending?: boolean;
};

export function LogoutConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  pending = false,
}: LogoutConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        overlayClassName="z-[10010] bg-landing-ink-950/55 backdrop-blur-[6px]"
        className="z-[10020] max-w-[calc(100vw-28px)] gap-0 overflow-hidden rounded-[20px] border border-landing-border bg-landing-white p-0 text-landing-text shadow-[0_28px_90px_rgba(8,8,12,0.42)] sm:max-w-[420px]"
      >
        <div className="h-1.5 w-full bg-landing-red" />
        <div className="p-5 sm:p-7">
          <AlertDialogHeader className="text-left">
            <div className="flex items-center justify-between">
              <span className="landing-eyebrow text-landing-red">TU SESIÓN</span>
              <span className="flex size-10 items-center justify-center rounded-xl border border-landing-red/20 bg-landing-red/5 text-landing-red">
                <LogOut className="size-[18px]" aria-hidden="true" />
              </span>
            </div>
            <AlertDialogTitle className="font-display mt-3 text-[30px] font-bold leading-[1.05] tracking-[-0.02em] sm:text-[34px]">
              ¿Cerramos por ahora?
            </AlertDialogTitle>
            <AlertDialogDescription className="mt-2 text-[15px] leading-relaxed text-landing-muted">
              Tu avance queda guardado. Podés volver a Mi Aula cuando quieras.
            </AlertDialogDescription>
          </AlertDialogHeader>

          <div className="mt-5 flex items-center gap-2 rounded-xl border border-landing-success/20 bg-landing-success/[0.07] px-3.5 py-3 text-sm font-semibold text-landing-success">
            <span className="flex size-5 items-center justify-center rounded-full bg-landing-success text-white">
              <Check className="size-3.5" strokeWidth={3} aria-hidden="true" />
            </span>
            Todo tu progreso está a salvo
          </div>

          <AlertDialogFooter className="mt-6 gap-2.5 sm:flex-col sm:space-x-0">
            <AlertDialogCancel className="group mt-0 h-12 w-full justify-between rounded-xl border-landing-ink-900 bg-landing-ink-900 px-4 text-landing-on-dark shadow-none hover:bg-[#342D27] hover:text-landing-on-dark">
              Seguir en AcademIA
              <ArrowRight
                className="size-4 transition-transform group-hover:translate-x-0.5"
                aria-hidden="true"
              />
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={onConfirm}
              disabled={pending}
              className="h-11 w-full rounded-xl border border-transparent bg-transparent text-landing-red shadow-none hover:border-landing-red/20 hover:bg-landing-red/5"
            >
              <LogOut className="mr-2 size-4" aria-hidden="true" />
              {pending ? "Cerrando…" : "Sí, cerrar sesión"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
